import { AbstractFeatureEntityStore } from '@y42/feature';
import { DatasourceGitFactoryService } from './datasource-git-factory.service';
import { DatasourceState } from './datasource.model';

const initialState: DatasourceState = {
  loading: true,
  last_used: {},
  starred: {},
  ui: {},
  active: null,
};

export abstract class DatasourceStore<
  State extends DatasourceState = DatasourceState,
> extends AbstractFeatureEntityStore<State> {
  constructor(protected readonly name: string, protected readonly gitFactory: DatasourceGitFactoryService) {
    super({ name, gitFactory, initialState: initialState as State });
  }
}
